import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const Step = ({ n, title, sub, state }) => (
  <div
    className={cn(
      "flex items-center gap-3 rounded-xl border px-3 py-2.5 min-w-0 transition-colors motion-reduce:transition-none",
      state === "active" && "border-red-500/40 bg-red-500/[0.05] dark:bg-red-500/[0.07]",
      state === "done" && "border-emerald-500/30 bg-emerald-500/[0.04]",
      state === "idle" && "border-border dark:border-white/[0.08]"
    )}
    data-testid={`contract-step-${n}`}
    aria-current={state === "active" ? "step" : undefined}
  >
    <span
      className={cn(
        "h-7 w-7 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 border",
        state === "active" && "bg-red-600 border-red-600 text-white",
        state === "done" && "bg-emerald-500/15 border-emerald-500/40 text-emerald-500",
        state === "idle" && "bg-foreground/[0.04] dark:bg-white/[0.05] border-border dark:border-white/[0.1] text-muted-foreground"
      )}
    >
      {state === "done" ? <Check className="h-3.5 w-3.5" /> : n}
    </span>
    <div className="min-w-0">
      <p className={cn("text-[13px] font-semibold leading-tight truncate", state === "idle" && "text-muted-foreground")}>{title}</p>
      <p className="text-[11px] text-muted-foreground leading-tight truncate hidden min-[420px]:block">{sub}</p>
    </div>
  </div>
);

export const StepperBar = ({ step, tf }) => (
  <div className="grid grid-cols-2 gap-2" data-testid="contract-stepper">
    <Step n={1} state={step > 1 ? "done" : "active"} title={tf("Informations générales")} sub={tf("Détails du contrat")} />
    <Step n={2} state={step === 2 ? "active" : "idle"} title={tf("Validation")} sub={tf("Vérifiez les informations détectées")} />
  </div>
);
